
import React, {useState, useEffect} from "react";
import { BASE_URL } from "../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Row, Col, Container, Card, Button, InputGroup} from 'react-bootstrap';
//import {OverlayTrigger, Tooltip, Row, Col, Container, Card, Button, InputGroup } from "react-bootstrap";
import '../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";

function Common_Mst() {

  const [hdnirn, setHdnIRN] = useState('');
  const [txtcommonTypeDesc, setTxtCommonTypeDesc] = useState('');
  const [ddlcommType, setDdlCommType] = useState('');
  const [ddlcommTypes, setDdlCommTypes] = useState([]);
  //const [rdcommontype, setRDCommonType] = useState('State');
  const [comm_masterData, setComm_MasterData] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const [errors, setErrors] = useState({});

  const [ddlcommTypeSearch, setDdlCommTypeSearch] = useState('');

  useEffect(() => {

    populate_ddl();

  }, []);

  const populate_ddl = async () => {

    try {

      setDdlCommTypes([]);
      const response = await axios.get(`${BASE_URL}/api/ddl_comm_types`);

      if (response.data && response.data.length > 0) {
        setDdlCommTypes(response.data);
      }

    } catch (err) {
      console.error("Error loading Data in Common_Master", err);
    }

  }

  useEffect(() => {

    populateData();

  }, [ddlcommTypeSearch]);

  const populateData = async () => {

    try {

      setComm_MasterData([]);
      const response = await axios.get(`${BASE_URL}/api/get_common_master_types`,
        { params: { p_type: ddlcommTypeSearch || '0' } });

      if (response.data && response.data.length > 0) {
        setComm_MasterData(response.data);
      }

    } catch (err) {
      console.error("Error loading Data in Common_Master", err);
    }

  }

  const handleRowClick = async (irn, comm_type_desc, comm_type) => {
    try {

      // var lv_Type = '';

      // if (comm_type_desc === 'Emp Designation') {
      //   lv_Type = 'DESIG';
      // }
      // else if (comm_type_desc === 'Emp Status') {
      //   lv_Type = 'EMP_STAT';
      // }
      // else if (comm_type_desc === 'Gender') {
      //   lv_Type = 'GENDER';
      // }
      // else if (comm_type_desc === 'Status') {
      //   lv_Type = 'STATUS';
      // }

      setHdnIRN(irn);
      setTxtCommonTypeDesc(comm_type_desc);
      setDdlCommType(comm_type);
      setIsEditable(true);

    } catch (error) {
      console.error('Error fetching Level 3 group data:', error);
    }
  };

  const handleClear = () => {

    setHdnIRN('');
    setDdlCommType('0');
    setDdlCommTypeSearch('0');
    setTxtCommonTypeDesc('');
    setIsEditable(false);

  };

  const handleNewRow = () => {

    setHdnIRN('');
    setDdlCommType('0');
    setTxtCommonTypeDesc('');
    setIsEditable(true);

  };

  const handleSave = async () => {

    const newErrors = {};

    if (!txtcommonTypeDesc) {
      newErrors.txtcommonTypeDesc = "Please enter Common Type Description.";
      toast.error("Please enter Common Type Description.");
    }
    else if (ddlcommType === '0') {
      newErrors.ddlcommType = "Please select Common Type.";
      toast.error("Please select Common Type.");
    }

    // ================= FINAL =================
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstErrorKey = Object.keys(newErrors)[0];
      if (firstErrorKey) {
        const el = document.getElementsByName(firstErrorKey)[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus(); // 🔥 bonus (cursor goes there)
        }
      }
      return;
    }

    const isConfirmed = window.confirm("Save Common Type ?");
    if (!isConfirmed) return;

    try {
      // Adjust the API endpoint and method based on your backend
      const payload = {
        irn: hdnirn,
        commonType: ddlcommType,
        commonTypeDesc: txtcommonTypeDesc,
      };

      await axios.post(`${BASE_URL}/api/save_common_master`, payload);

      //alert("Saved successfully!");
      toast.success(`Saved successfully.`);

      // Disable editing after save
      setIsEditable(false);
      setHdnIRN('');
      setTxtCommonTypeDesc('');
      setDdlCommType('0');
      setDdlCommTypeSearch('0');

    } catch (error) {
      console.error("Error saving record:", error);
      alert("Failed to save Common Master.", error);
    }

  };

  return (

      <Container fluid className="p-3">

        <Card className="mb-3 p-3">

        <Row className="mb-3">

          <Col md={7} className="d-flex align-items-center">
            <InputGroup>
              <InputGroup.Text style={{ width: "100px" }}>
                Description
              </InputGroup.Text>
              <input
                //className="form-control"
                className={`form-control ${errors.txtcommonTypeDesc ? "is-invalid" : ""}`}
                type="text"
                name="txtcommonTypeDesc"
                value={txtcommonTypeDesc}
               // onChange={(e) => setTxtCommonTypeDesc(e.target.value)}
                onChange={(e) => {
                  const { name, value } = e.target;
                  setTxtCommonTypeDesc(value);
                  setErrors(prev => ({
                    ...prev,
                    [name]: ""
                  }));
                }}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

          <Col md={5} className="d-flex align-items-center">
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}>
                Common Type
              </InputGroup.Text>
              <select
                //className="form-select"
                className={`form-select ${errors.ddlcommType ? "is-invalid" : ""}`}
                name="ddlcommType"
                value={ddlcommType}
                disabled={!isEditable}
               // onChange={(e) => setDdlCommType(e.target.value)}
                onChange={(e) => {
                  const { name, value } = e.target;
                  setDdlCommType(value);
                  setErrors(prev => ({
                    ...prev,
                    [name]: ""
                  }));
                }}
              >
                <option value="0">-- Select Type --</option>
                {ddlcommTypes.map(type => (
                      <option key={type.comm_type} value={type.comm_type}>{type.ddl_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

        </Row>

        <Row className="mt-1">

          <Col md={12}>
            <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">

              <Button style={{ marginTop: '10px', width: "130px" }}
                //className="btn btn-primary me-2" 
                variant="primary"
                disabled={isEditable} onClick={handleNewRow}>New</Button>
              <Button style={{ marginTop: '10px', width: "130px" }}
                //className="btn btn-secondary me-2" 
                variant="secondary"
                onClick={handleClear}>Clear </Button>
              <Button style={{ marginTop: '10px', width: "130px" }}
                //className="btn btn-success" 
                variant="success"
                onClick={handleSave} disabled={!isEditable}>Save</Button>
            </div>
          </Col>

        </Row>

        </Card>

        <Card className="p-3">

          {/* <Row className="mb-3">
            <Col md={6} className="d-flex align-items-center">
              <label className="label-color-common form-label fw-bold">Type :</label> &nbsp;&nbsp;
              <div className="d-flex flex-wrap gap-2">
                {['Emp Designation', 'Emp Status', 'Gender', 'Status'].map((option) => (
                  <Form.Check inline key={option} type="radio" label={option} name="rdcommontype"
                    value={option} checked={rdcommontype === option} onChange={handleTypeRadioButton} />
                ))}
              </div>
            </Col>
          </Row> */}

        <Row className="mb-3">
          <Col md={4} className="d-flex align-items-start">
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}>
                Filter Type
              </InputGroup.Text>
              <select className="form-select" name="ddlcommTypeSearch" value={ddlcommTypeSearch}
                onChange={(e) => {
                  const { name, value } = e.target;
                  setDdlCommTypeSearch(value);
                }}>
                <option value="0">-- Select Type --</option>
                {ddlcommTypes.map(type => (
                  <option key={type.comm_type} value={type.comm_type}>{type.ddl_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>
        </Row>

          <div style={{ minHeight: '220px' }} className="table-wrapper">

            <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table hover-table-rcpt">

              <thead>
                <tr>
                  {/* <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', display: 'none' }}>irn</th> */}
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '400px' }}>Common Type Desc</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>Common Type</th>
                </tr>
              </thead>
              <tbody>
                {comm_masterData.length === 0 ? (
                  <tr>
                    <td colSpan="2" style={{ textAlign: 'center' }}>No Data Found</td>
                  </tr>
                ) : (
                  comm_masterData.map((item, index) => (
                    <tr key={index} onClick={() => handleRowClick(item.irn, item.comm_desc, item.comm_type)} style={{ cursor: 'pointer', height: '40px' }}>
                      {/* <td style={{ display: 'none' }}>{item.irn}</td> */}
                      <td>{item.comm_desc}</td>
                      <td>{item.comm_type_desc}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

        </Card>

      </Container>
    )
}

export default Common_Mst;
